
<div *ngIf="!editing &amp;&amp; !deaultEditView"><span class="float-left" *ngIf="!showAsHyperlink">{{ displayValue | date: 'yyyy-MM-dd' }}</span><a class="float-right micro-input-edit-link" *ngIf="allowEditing" href="javascript:void(0)" (click)="edit();"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
<div class="input-group" *ngIf="editing || deaultEditView">
  <input class="form-control form-control-sm" [(ngModel)]="editorValue" [type]="type">
  <div class="input-group-append" style="flex-direction: row;">
    <datepicker class="right" [(ngModel)]="editorValue"></datepicker>
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    <button class="btn btn-sm btn-primary" type="button" (click)="save()">Save</button>
  </div>
</div>